module.exports = __webpack_public_path__ + "img/h2_bg02.0c37bcee.png";